import React from 'react';

function EPFaq() {
  return (
    <div>EPFaq</div>
  );
}

export default EPFaq;
